import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Quill Editor styles
import { getExhibitionById, updateExhibition } from "./request";
import { useAuth } from "../context/AuthContext";
import { IMAGE_URL } from "../constants/Consts";
import pdf from '../../assets/icons/pdf.svg';
import Button from '@mui/material/Button';

const EditExhibition = () => {
    const location = useLocation();  
    const { exhibitionId } = location.state; 
  const navigate = useNavigate();
  const [year, setYear] = useState("");
  const [saal, setSaal] = useState("");
  const [pdfBase64, setPdfBase64] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [coverPreview, setCoverPreview] = useState(null);
  const [muqadma, setMuqadma] = useState("");
  const { authToken } = useAuth();
  const IMAGE_SHOW = `${IMAGE_URL}exhibitionImages`
  const PDF_SHOW = `${IMAGE_URL}exhibitionPdf`;

  // Fetch Exhibition Details
  useEffect(() => {
    const fetchExhibition = async () => {
      try {
        const response = await getExhibitionById(authToken, exhibitionId);
        if (response.Result) {
          setYear(response.Exhibition.year);
          setCoverImage(response.Exhibition.image);
          setCoverPreview(response.Exhibition.image);
          setMuqadma(response.Exhibition.muqadma);
          setSaal(response.Exhibition.saal)
          setPdfBase64(response.Exhibition?.pdf)
        }
      } catch (error) {
        console.error("Error fetching exhibition:", error);
        alert("Error fetching exhibition.");
        navigate("/exhibition");
      }
    };

    fetchExhibition();
  }, [exhibitionId, authToken, navigate]);

  // Convert image to Base64 and preview
  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        alert("Image size must be less than 5MB.");
        return;
      }
      if (!file.type.startsWith("image/")) {
        alert("Please upload a valid image file.");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setCoverImage(reader.result);
        setCoverPreview(reader.result);
      };
    }
  };

  // Handle Form Submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!year || !coverImage || !muqadma) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    const formData = {
      year,
      saal,
      coverImage,
      muqadma,
      pdf:pdfBase64
    };

    try {
      const response = await updateExhibition(authToken, exhibitionId, formData);
      if (response.Result) {
        alert("Exhibition updated successfully!");
        navigate("/exhibition");
      } else {
        alert(response.data.Msg || "Failed to update exhibition.");
      }
    } catch (error) {
      console.error("Error updating Exhibition:", error);
      alert("An error occurred while updating the exhibition.");
    }
  };
  const handlePdfUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type and size
      if (file.type !== "application/pdf") {
        alert("Please upload a valid PDF file.");
        return;
      }
      

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setPdfBase64(reader.result);
      };
    }
  };
  return (
    <div className="mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Edit Exhibition</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Year Input */}
        <div>
          <label className="block font-semibold">Year:</label>
          <input
            type="text"
            className="w-full border p-2 rounded-md"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            placeholder="Enter year"
          />
        </div>
        <div>
          <label className="block font-semibold">Year(Urdu):</label>
          <input
            type="text"
            className="w-full border p-2 rounded-md"
            value={saal}
            onChange={(e) => setSaal(e.target.value)}
            placeholder="Enter year"
          />
        </div>
        {/* Cover Image Upload */}
        <div>
          <label className="block font-semibold">Cover Image:</label>
          <input
            type="file"
            className="w-full border p-2 rounded-md"
            accept="image/*"
            onChange={handleImageUpload}
          />

          {/* Image Preview */}
          {coverPreview && (
            <div className="mt-3">
              <img
               src={coverPreview.endsWith('jpeg')?`${IMAGE_SHOW}/${coverPreview}` : coverPreview}
                alt="Cover Preview"
                className="w-40 h-32 object-cover rounded-md shadow"
              />
            </div>
          )}
        </div>

        {/* Muqadma (Quill Editor) */}
        <div>
          <label className="block font-semibold">Muqadma:</label>
          <ReactQuill
            value={muqadma}
            onChange={setMuqadma}
            className="bg-white"
          />
        </div>
{/* PDF Upload */}
<div>
            <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="pdf">
              Upload PDF
            </label>
            <input
              id="pdf"
              type="file"
              accept=".pdf"
              onChange={handlePdfUpload}
              className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              aria-label="Upload PDF file"
            />
          </div>

          {pdfBase64 && (
    <div className="mt-4">
        {pdfBase64.startsWith('data:application/pdf') ? (
            <a
                href={pdfBase64}
                download={`uploaded.pdf`}
                className="text-blue-500 underline"
            >
             <img src={pdf} alt="" className='size-7'/>   Download PDF
            </a>
        ) : (
            <a
                href={`${PDF_SHOW}/${pdfBase64}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline flex align-middle gap-2"
            >
               <img src={pdf} alt="" className='size-7'/>  View PDF
            </a>
        )}
    </div>
)}
        {/* Submit Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={false} // No loading state in this specific case, but for consistency
        >
          Update
        </Button>
      </form>
    </div>
  );
};

export default EditExhibition;